import React from 'react';
import { Box } from '../element';

const OneColumnLayout = ({ contentClassName, ...props }) => (
  <Box direction="row" fill={true} className="pageWrapper">
    <Box wrap={true} direction="row" fill={true} className={contentClassName}>
      {props.children}
    </Box>
  </Box>
);

export default OneColumnLayout;
